import { ADD_OR_UPDATE_PICKUP_POINT,PICKUP_POINT_CLEAR } from "../checkoutConstType";


export const PickupPointReducer=(state={},action)=> {
  

    switch (action.type) {
        case ADD_OR_UPDATE_PICKUP_POINT:
             return  {...state,pickupoint:action.payload}
             case PICKUP_POINT_CLEAR:
                return  {...state,pickupoint:action.payload}

        default:return state;
    }
}